export default '/build/af6271c0.svg'